"use strict";
var prevGSScrollpos = window.pageYOffset;
var headerGSsticky = document.querySelector(".zaza-sticky-header");
var headerGSstickyUp = headerGSsticky.classList.contains("zaza-sticky-header-up");
let headerGSparentblock = headerGSsticky;
let headerOffset = 250;

window.addEventListener("scroll", function () {
    if (headerGSsticky && window.innerWidth > 1024 && window.scrollY > headerOffset) {
        headerGSparentblock.classList.add("zaza-sticky-enable");
        document.body.classList.add("zaza-sticky-active");
        document.body.style = "--greenshift-sticky-height:" + headerGSparentblock.clientHeight + "px";
    } else {
        headerGSparentblock.classList.remove("zaza-sticky-enable");
        document.body.classList.remove("zaza-sticky-active");
        document.body.style.removeProperty("--greenshift-sticky-height");
    }
});

